module.exports = __webpack_public_path__ + "img/image-announcement-bg.9eaf6585.png";